export enum InformationBoxType {
  Default,
  Information,
  Success,
  Danger,
  Error,
}
